module.exports = __webpack_public_path__ + "img/logo.0cfffa0b.jpg";